import '@/assets/css/style.css'

import { createPinia } from 'pinia'
import { createApp } from 'vue'

import { OhVueIcon, addIcons } from 'oh-vue-icons'
import {
  BiCalendarDate,
  BiCheckLg,
  BiChevronDown,
  BiFileEarmarkBarGraphFill,
  BiGearFill,
  CoClock,
  CoFilter,
  CoPrint,
  FaClipboardList,
  FaEdit,
  FaMicrochip,
  FaMinus,
  FaNetworkWired,
  FaPlus,
  FaTruck,
  GiTeePipe,
  HiDocumentReport,
  HiRefresh,
  HiSolidArrowSmLeft,
  HiSolidClock,
  IoClose,
  IoWarning,
  MdDownloadforofflineRound,
  MdOilbarrel,
  MdRecycling,
  MdVideogameassetOutlined,
  MdVideogameassetoffOutlined,
  OiMute,
  PrPencil,
  PrSignIn,
  PrWifi,
  RiChargingPileFill,
  RiCloseFill,
  RiDashboard2Fill,
  RiGlobalLine,
  RiPrinterLine,
} from 'oh-vue-icons/icons'

import App from './App.vue'
import InputMask from './plugins/inputmask'
import Tooltip from './plugins/tooltip'

import { useDark } from '@vueuse/core'
import router from './router'

addIcons(
  RiDashboard2Fill,
  GiTeePipe,
  FaEdit,
  FaMicrochip,
  MdOilbarrel,
  BiGearFill,
  FaClipboardList,
  RiGlobalLine,
  HiDocumentReport,
  MdRecycling,
  FaNetworkWired,
  FaPlus,
  FaMinus,
  OiMute,
  BiFileEarmarkBarGraphFill,
  HiSolidClock,
  FaTruck,
  CoPrint,
  HiRefresh,
  MdVideogameassetOutlined,
  MdVideogameassetoffOutlined,
  BiChevronDown,
  BiCalendarDate,
  RiPrinterLine,
  PrSignIn,
  PrPencil,
  HiSolidArrowSmLeft,
  RiCloseFill,
  BiCheckLg,
  CoFilter,
  CoClock,
  IoClose,
  IoWarning,
  MdDownloadforofflineRound,
  RiChargingPileFill,
  PrWifi,
)

useDark()

const app = createApp(App)

app.component('v-icon', OhVueIcon)

app.use(createPinia())
app.use(InputMask)
app.use(Tooltip)
app.use(router)

app.mount('#app')
